import Axios from '@/api/http'
import { ElMessage } from 'element-plus';

/**
 * 新增数据工坊
 * */
export function apiAddapprovalreport(date) {
  return Axios({
    method: 'post',
    url: '/api/addapprovalreport',
    data: date
  })
}

/**
 * 查询应用列表
 * */
export function getapprovallist(date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovallist',
    data: date
  })
}

/**
 * 查询应用、仪表盘列表
 * */
export function getapprovalandreportlist(date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalandreportlist',
    data: date
  })
}

/**
 * 批量删除
 * */
 export function deleteapporfolder(date) {
  return Axios({
    method: 'post',
    url: '/api/deleteapporfolder',
    data: date
  })
}
/**
 * 获取列表
 * */
export function getfolderandapprovalreportlist(date) {
  return Axios({
    method: 'post',
    url: '/api/getfolderandapprovalreportlist',
    data: date
  })
}

/**
 * 删除数据工坊
 * */
export function apiDeleteapprovalreport(date) {
  return Axios({
    method: 'post',
    url: '/api/deleteapprovalreport',
    data: date
  })
}

/**
 * 获取预览数据
 * */
export function apiGetapprovalreportpreview(date, orj) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalreportpreview',
    data: date
  }).then(res => {
    if (res.code === -1) {
      ElMessage.error(res.msg);
      res.data = [];
      res.code = 0;
    } else if (res.code === 0) {
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i]) {
          for (let a in res.data[i]) {
            if (orj && orj[a] && (orj[a] === 'text' || orj[a] === 'textarea') && typeof res.data[i][a] !== 'string') res.data[i][a] = JSON.stringify(res.data[i][a])
            res.data[i][a] = reportpreviewResult(res.data[i][a],a);
          }
        }
      }
    }
    return res;
  })
}
export function apiGetapprovalreportpreviewGrid(date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalreportpreview',
    data: date
  }).then(res => {
    console.log('请求的接口拦截', res)
    if (res.code === -1) {
      ElMessage.error(res.msg);
      res.data = [];
      res.code = 0;
    } else if (res.code === 0) {
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i]) {
          for (let a in res.data[i]) {
            res.data[i][a] = reportpreviewResultGrid(res.data[i][a],a);
            // console.log('收到解构对象', res.data[i][a])
          }
        }
      }
    }
    return res;
  })
}
function reportpreviewResult(res,a){
  //apiGetapprovalreportpreviews接口数据处理使用
  if(res instanceof Object){//如果为对象
    if(res instanceof Array){//如果为数组
      let realname = []
      res.forEach((ele) => {
        if(ele.realname){
          realname.push(ele.realname)
        } else if (ele.roleId || ele.organizationId) {
          realname.push(ele.name)
        } else if (ele.response){
          if (typeof ele.response === 'string' && ele.response.indexOf("-")) realname.push(ele.response.substring(ele.response.indexOf("-")+1,ele.response.length))
        }
      });
      res = realname.length>0?realname.join('，'):res
    }else{//为对象
      if(res.realname){
        res = res.realname
      }else{
        for(let b in res){
          res[b] = reportpreviewResult(res[b],b);
        }
      }
    }
  }
  if (a === '状态') {
    let arr = ['进行中', '已通过', '未通过', '已撤销'];
    res = arr[res];
  } else if (a === '归档状态') {
    const ars = ['未归档', '已归档']
    res = ars[res]
  } else if (a === '存证状态') {
    const ars = ['未存证', '', '已存证']
    res = ars[res]
  } else if (a === '预支付状态') {
    const ars = ['未支付', '已支付']
    res = ars[res]
  } else if (a === '支付状态') {
    const ars = ['未支付', '支付成功', '支付失败']
    res = ars[res]
  }
  return res;
}
function reportpreviewResultGrid(res,a){
  //apiGetapprovalreportpreviews接口数据处理使用
  if(res instanceof Object){//如果为对象
    if(res instanceof Array){//如果为数组
      let realname = []
      res.forEach((ele) => {
        if (ele.userId) {
          // 联系人就不要处理了
        } else if(ele.realname){
          realname.push(ele.realname)
        } else if (ele.roleId) {
          realname.push(ele.name)
        } else if (ele.response){
          const img = {
            name: ele.response.substring(ele.response.indexOf("-")+1,ele.response.length),
            response: ele.response
          }
          realname = realname.concat(img)
        }
      });
      if (res.length > 0 && res[0].response) {
        res = realname
      } else {
        res = realname.length>0?realname.join('，'):res
      }
    }else{//为对象
      if(res.realname){
        res = res.realname
      } else if (res.roleId) {
        res = res.name
      } else{
        for(let b in res){
          res[b] = reportpreviewResultGrid(res[b],b);
        }
      }
    }
  }
  if (a === '状态') {
    let arr = ['进行中', '已通过', '未通过', '已撤销'];
    res = arr[res];
  } else if (a === '归档状态') {
    const ars = ['未归档', '已归档']
    res = ars[res]
  }
  return res;
}

/**
 * 修改数据工坊
 * */
export function apiUpdateapprovalreport(date) {
  return Axios({
    method: 'post',
    url: '/api/updateapprovalreport',
    data: date
  })
}

/**
 * 根据id获取配置项
 * */
export function apiGetapprovalreport(date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalreport',
    data: date
  })
}

/**
 * 根据ids获取配置项
 * */
export function getapprovalreportlist(date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalreportlist',
    data: date
  })
}

/**
 * 获取计算公式
 * */
export function apiGetformulalist(date) {
  return Axios({
    method: 'post',
    url: '/api/getformulalist',
    data: date,
    interceptUrl: true
  })
}

/**
 * 批量报表排序
 * */
export function apiBatchupdateapprovalreportorders(date) {
  return Axios({
    method: 'post',
    url: '/api/batchupdateapprovalreportorders',
    data: date
  })
}

/**
 * 获取标签
 * */
export function getapprovalcategorylabellist(date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalcategorylabellist',
    data: date,
    interceptUrl: true
  })
}

/**
 * 获取标签(客户端)
 * */
export function getopenapprovalcategorylabellist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovalcategorylabellist',
    data: date,
    interceptUrl: true
  })
}

/**
 * 获取分组
 * */
export function getapprovalcategorylist(date) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalcategorylist',
    data: date,
    interceptUrl: true
  })
}

/**
 * 获取应用
 * */
export function getappandreportlist(date) {
  return Axios({
    method: 'post',
    url: '/api/getappandreportlist',
    data: date,
    interceptUrl: true
  })
}

/**
 * 定时机器人获取执行动作目标数据表接口
 * */
export function getappanddataboardshandreportlist(date) {
  return Axios({
    method: 'post',
    url: '/api/getappanddataboardshandreportlist',
    data: date,
    interceptUrl: true
  })
}

/**
 * 获取应用(带权限)
 * */
export function getappanddataboardshandreportlists(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getappanddataboardshandreportlists',
    data: date,
    interceptUrl: true
  })
}

/**
 * 获取联动模板
 * */
export function getapporreport(date) {
  return Axios({
    method: 'post',
    url: '/api/getapporreport',
    data: date,
    interceptUrl: true
  })
}

/**
 * 手动同步
 * */
export function refreshapprovalreport(date) {
  return Axios({
    method: 'post',
    url: '/api/refreshapprovalreport',
    data: date,
    interceptUrl: true
  })
}
